import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import PressableStyled from './PressableStyled';
import Colors from '../constants/Colors';

interface RadioButtonProps {
  selected: boolean,
  select: () => void,
  title: string,
}

const RadioButton = ({ selected, select, title }: RadioButtonProps) => <PressableStyled
  style={styles.container}
  onPress={select}
>
  <View style={[styles.outerCircle, selected && styles.outerCircleSelected]}>
    {selected && <View style={styles.innerCircle} />}
  </View>
  <Text>{title}</Text>
</PressableStyled>;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 4,
    marginEnd: 24,
  },
  outerCircle: {
    width: 16,
    aspectRatio: 1,
    borderRadius: 100,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlack100,
    backgroundColor: Colors.light.hereworksBlack50,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 4,
    marginEnd: 8,
  },
  outerCircleSelected: {
    backgroundColor: '#FFF',
    borderColor: Colors.light.hereworksBlue500,
  },
  innerCircle: {
    height: 8,
    aspectRatio: 1,
    borderRadius: 100,
    backgroundColor: Colors.light.hereworksBlue500,
  },
});

export default RadioButton;
